import * as React from "react";
import PropTypes from "prop-types";
// Components
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "css/brm-react-tabs.css";
import SystemAssetTable from "brm/tables/details/SystemAssetTable";
import DynamicSubTabSelector from "components/elements/DynamicSubTabSelector";
import { DetailsTableMap } from "brm/tables/details/DetailsTableMap";
import { DetailTableType } from "features/brm";

const systemMenu = [DetailTableType.TARGETS];

const riskMenu = [DetailTableType.RISKS, DetailTableType.ASSETS, DetailTableType.UNDESIRED_EVENTS];

const attacksMenu = [
  DetailTableType.THREAT_EVENTS,
  DetailTableType.ATTACKS,
  { ...DetailTableType.ATTACKERS, isDisabled: true },
];

const controlsMenu = [DetailTableType.ALLOCATED_CONTROLS];

const vulnerabilityMenu = [DetailTableType.VULNERABILITY_CONDITIONS, DetailTableType.VULNERABILITY_FINDINGS];

const accessMenu = [
  DetailTableType.ACCESS_POINTS,
  DetailTableType.ATTACK_SURFACES,
  DetailTableType.ATTACK_VECTORS,
  DetailTableType.ENTRY_POINTS,
];

const AttackerDetails = ({ selectedElement }) => {
  const elementNameInUrl = DetailTableType.ATTACKERS.key;
  const [selectedSystemContext, setSelectedSystemContext] = React.useState(DetailTableType.TARGETS.key);
  const [selectedAccessContext, setSelectedAccessContext] = React.useState(DetailTableType.ACCESS_POINTS.key);
  const [selectedRiskContext, setSelectedRiskContext] = React.useState(DetailTableType.RISKS.key);
  const [selectedAttackContext, setSelectedAttackContext] = React.useState(DetailTableType.THREAT_EVENTS.key);
  const [selectedVulContext, setSelectedVulContext] = React.useState(DetailTableType.VULNERABILITY_CONDITIONS.key);
  const [selectedControlsContext, setSelectedControlsContext] = React.useState(DetailTableType.ALLOCATED_CONTROLS.key);
  const [curr, setCurr] = React.useState("");

  return (
    <Tabs>
      <TabList>
        <Tab onClick={() => setCurr(DetailTableType.SYSTEM.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.SYSTEM.name}
            menu={systemMenu}
            setSelectedContext={setSelectedSystemContext}
            curr={curr}
          />
        </Tab>

        <Tab onClick={() => setCurr(DetailTableType.ACCESS.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.ACCESS.name}
            menu={accessMenu}
            setSelectedContext={setSelectedAccessContext}
            curr={curr}
          />
        </Tab>
        <Tab onClick={() => setCurr(DetailTableType.SYSTEM_ASSETS.name)}>{DetailTableType.SYSTEM_ASSETS.name}</Tab>

        <Tab onClick={() => setCurr(DetailTableType.RISK.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.RISK.name}
            menu={riskMenu}
            setSelectedContext={setSelectedRiskContext}
            curr={curr}
          />
        </Tab>
        <Tab onClick={() => setCurr(DetailTableType.ATTACK.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.ATTACK.name}
            menu={attacksMenu}
            setSelectedContext={setSelectedAttackContext}
            curr={curr}
          />
        </Tab>
        <Tab onClick={() => setCurr(DetailTableType.VULNERABILITIES.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.VULNERABILITIES.name}
            menu={vulnerabilityMenu}
            setSelectedContext={setSelectedVulContext}
            curr={curr}
          />
        </Tab>
        <Tab onClick={() => setCurr(DetailTableType.CONTROLS.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.CONTROLS.name}
            menu={controlsMenu}
            setSelectedContext={setSelectedControlsContext}
            curr={curr}
          />
        </Tab>
      </TabList>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedSystemContext}
        />
      </TabPanel>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedAccessContext}
        />
      </TabPanel>

      <TabPanel>
        <SystemAssetTable elementNameInUrl={elementNameInUrl} selectedElement={selectedElement} showDelete={false} />
      </TabPanel>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedRiskContext}
        />
      </TabPanel>
      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedAttackContext}
        />
      </TabPanel>
      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedVulContext}
        />
      </TabPanel>
      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedControlsContext}
        />
      </TabPanel>
    </Tabs>
  );
};

AttackerDetails.propTypes = {
  selectedElement: PropTypes.any,
};

export default AttackerDetails;
